module.exports = __webpack_public_path__ + "static/media/az.33309571.png";